import React from 'react';
import { Box, Container, Paper, Typography } from '@mui/material';

/**
 * AuthLayout component provides a consistent layout for authentication pages
 * such as login, forgot password, and reset password.
 * 
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render within the layout
 * @returns {React.ReactElement} The AuthLayout component
 */
const AuthLayout = ({ children }) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: '#f5f5f5',
      }}
    >
      <Box
        component="header"
        sx={{
          py: 2,
          px: 3,
          bgcolor: 'white',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
          textAlign: 'center', // Center align the header content
        }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h6"
            component="div"
            sx={{ fontWeight: 600, color: 'primary.main' }}
          >
            Biztimize
          </Typography>
        </Container>
      </Box>

      <Box
        component="main"
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {children}
      </Box>

      <Box
        component="footer"
        sx={{
          py: 2,
          textAlign: 'center',
          bgcolor: 'white',
          borderTop: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Container maxWidth="lg">
          <Typography variant="body2" color="text.secondary">
            © {new Date().getFullYear()} Biztimize. All rights reserved.
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};

export default AuthLayout;